import { Stack } from "@mui/material";
import Chip from "components/Chip";

type TransientJobLogChipsProps = {
  formatLabel?: (value: string) => string;
  isOn?: (value: string) => boolean;
  onToggle: (value: string) => void;
  values: readonly string[];
};

export const TransientJobLogChips = ({ formatLabel, isOn, onToggle, values }: TransientJobLogChipsProps) => {
  if (values.length === 0) return null;
  return (
    <Stack className="w-full flex-col items-start justify-start gap-2">
      {values.map((value) => (
        <Chip className="w-full" isOn={isOn?.(value)} key={value} onClick={() => onToggle(value)}>
          <span className="">{formatLabel?.(value) ?? value}</span>
        </Chip>
      ))}
    </Stack>
  );
};
